import { useMemo } from 'react';
import { enumWar } from '../constants/enumWar';

const useCombinedFilter = (data = []) => {
  return useMemo(() => {
    const stageFilter = {};
    const warFilter = {};

    data.forEach((item) => {
      const stage = item?.stageAddressLifeCycle;
      const stageId = stage?.id;
      if (stageId !== undefined && stageId !== null) {
        if (stageFilter[stageId]) {
          stageFilter[stageId].count += 1;
        } else {
          stageFilter[stageId] = { ...stage, count: 1 };
        }
      }

      const garantyId = item?.garantyId;
      if (garantyId !== undefined && garantyId !== null) {
        if (warFilter[garantyId]) {
          warFilter[garantyId].count += 1;
        } else {
          warFilter[garantyId] = {
            id: garantyId,
            name: enumWar[garantyId],
            count: 1,
          };
        }
      }
    });

    return {
      stageFilter,
      warFilter,
    };
  }, [data]);
};

export default useCombinedFilter;
